import { useDispatch, useSelector } from 'react-redux'
import * as React from 'react'
import NavBar from '../../structure/NavBar'
import { NavBarTop } from '../../structure/NavBarTop'
import ReplyIcon from '@mui/icons-material/Reply'
import {
  updateTopHeader,
  uplodateLoading
} from '../../../redux/features/common/commonSlice'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Utils from '../../constants/Utils'
import { EventDetailComponent } from './EventDetailComponent'
import urls from '../../constants/apiurl'
import ApiCaller from '../../constants/ApiCaller'
import { showDangerToast, showToast } from '../../constants/toaster'
import { EventSubmissionVideosList } from './EventSubmissionVideosList'
import { PlayVideoInModal } from '../../custom/PlayVideoInModal'


export const EventDetails = props => {

  const [videoSrc, setVideoSrc] = useState('')
  const [showPlayVideoModal, setShowPlayVideoModal] = useState(false)

  const [showUI, setShowUI] = useState({
    detail: true,
    totalSubmission: false,
    totalJoined: false
  })
  const [eventDetailsData, setEventDetailsData] = useState({})
  const { formatDate } = Utils();
  const router = useNavigate()
  const userData = useSelector(state => state?.userData)
  const dispatch = useDispatch()
  const { id } = useParams()
  useEffect(() => {
    dispatch(updateTopHeader('Event Manager'))
    console.log('123123', id)
    if (id) {
      getEventDetails()
      getUserRecentVideos()
    }
  }, [id])

  const handlePlayVideo = (url) => {
    setShowPlayVideoModal(true)
    setVideoSrc(url)
  }


  const handleResultAnnounce = async () => {
    try {
      dispatch(uplodateLoading(true))
      let path = urls.resultAnnounce + '?id=' + id
      let res = await ApiCaller.get({}, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(uplodateLoading(false))
        console.log(response?.data)
        showToast(response?.message)
        getEventDetails()
      } else {
        dispatch(uplodateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(uplodateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }

  const handlePauseVideo = () => {
    setShowPlayVideoModal(false)
    setVideoSrc('')
  }

  const getEventDetails = async () => {
    try {
      dispatch(uplodateLoading(true))
      let path = urls.eventDetails + '/' + id
      let res = await ApiCaller.get({}, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(uplodateLoading(false))
        console.log(response?.data)
        setEventDetailsData(response?.data)
      } else {
        dispatch(uplodateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(uplodateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }
  const getUserRecentVideos = async () => {

  }

  return (
    <>
      <NavBar />
      <div className='main-content'>
        <NavBarTop />
        <div className='header'>
          <div className='logo'>
            <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
          </div>
        </div>
        <div className='container-fluid mt--7'>
          <div className='row'>
            <div className='col-md-12 text-left'>
              <a
                onClick={() => {
                  showUI?.detail ? router("/event-manager") : setShowUI({
                    detail: true,
                    totalSubmission: false,
                    totalJoined: false
                  })
                }}
                className='btn btn-sm btn-primary text-white'
              >
                <ReplyIcon />
                Back
              </a>
            </div>
          </div>
          <div className='row card shadow'>
            <div className='col-md-12'>
              {showUI?.detail ? <EventDetailComponent eventDetails={eventDetailsData} onShowTotalSubmission={() => setShowUI({
                detail: false,
                totalSubmission: true,
                totalJoined: false
              })} 
              handleResultAnnounce={handleResultAnnounce}
              /> : showUI?.totalSubmission ? <EventSubmissionVideosList criteria={eventDetailsData?.winnerCriteria} handlePlayVideo={handlePlayVideo} handlePauseVideo={handlePauseVideo} id={id} eventDetails={eventDetailsData} /> : <></>}
              {showUI?.totalSubmission && <PlayVideoInModal
                videoSrc={videoSrc}
                show={showPlayVideoModal}
                onHide={() => handlePauseVideo()}
              />}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
